// import { Navbar, Nav, Container, NavDropdown, Badge } from 'react-bootstrap';
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLogoutMutation } from "../slices/usersApiSlice";
import { logout } from "../slices/authSlice";
import { Fragment, useEffect, useState } from "react";
import { useGetSiteConfigDetailsQuery } from "../slices/siteConfigApiSlice";

const Header = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const [websiteName, setWebsiteName] = useState("");

    const {
      data: siteConfigDetails,
    } = useGetSiteConfigDetailsQuery();
  
  useEffect(() => {
    if (siteConfigDetails) {
      const websiteNameObj = siteConfigDetails.find(
        (item) => item.key === "websiteName"
      );
      if (websiteNameObj) {
        setWebsiteName(websiteNameObj.value);
      }
    }
  }, [siteConfigDetails]);
  
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [logoutApiCall] = useLogoutMutation();

  const logoutHandler = async () => {
    try {
      await logoutApiCall().unwrap();
      dispatch(logout());
      navigate("/login");
    } catch (err) {
      console.error(err);
    }
  };
  const environment =
    process.env.REACT_APP_ENV === "development"
      ? "danger"
      : process.env.REACT_APP_ENV === "staging"
      ? "success"
      : "dark";

  return (
    <header>
      <Navbar
        variant="dark"
        className={`text-bg-${environment}`}
        collapseOnSelect
      >
        <Container
          fluid
          // className="text-bg-success"
        >
          <LinkContainer to="/">
            <Navbar.Brand>{websiteName}</Navbar.Brand>
          </LinkContainer>
          {environment === "danger" && <span>Development</span>}
          {environment === "success" && <span>Staging</span>}
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              {userInfo ? (
                <Fragment>
                  <NavDropdown
                    title={userInfo.name}
                    id="username"
                  >
                    <LinkContainer to="/profile">
                      <NavDropdown.Item>Profile</NavDropdown.Item>
                    </LinkContainer>
                    <NavDropdown.Item href="/register">
                      Register
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={logoutHandler}>
                      Logout
                    </NavDropdown.Item>
                  </NavDropdown>
                </Fragment>
              ) : (
                <Fragment>
                  <LinkContainer to="/login">
                    <Nav.Link>Sign In</Nav.Link>
                  </LinkContainer>
                  {/* <LinkContainer to="/register">
                    <Nav.Link>Register</Nav.Link>
                  </LinkContainer> */}
                </Fragment>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Navbar
        // collapseOnSelect
        // expand="lg"
        className="bg-body-secondary"
        // bg="primary"
        // data-bs-theme="dark"
        // variant="dark"
      >
        <Container fluid>
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
              {userInfo && (
                <Fragment>
                  <Nav.Link href="/programs">Programs</Nav.Link>
                  <Nav.Link href="/templates">Templates</Nav.Link>
                  <Nav.Link href="/playlists">Playlists</Nav.Link>
                  {/* <Nav.Link href="/songs">Songs</Nav.Link> */}

                  <NavDropdown
                    title="Songs"
                    id="collapsible-nav-dropdown"
                  >
                    <NavDropdown.Item href="/songs">Songs</NavDropdown.Item>
                    <NavDropdown.Item href="/songcontact">
                      Contacts
                    </NavDropdown.Item>
                  </NavDropdown>

                  <Nav.Link href="/addspromos">Adds/Promos</Nav.Link>
                  <NavDropdown
                    title="Admin"
                    id="collapsible-nav-dropdown"
                  >
                    <NavDropdown.Item href="/idents">Idents</NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="#action/3.4">
                      Separated link
                    </NavDropdown.Item>
                  </NavDropdown>
                  <NavDropdown
                    title="Reports"
                    id="collapsible-nav-dropdown"
                  >
                    <NavDropdown.Item href="#action/3.1">
                      Idents
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="#action/3.4">
                      Separated link
                    </NavDropdown.Item>
                  </NavDropdown>
                </Fragment>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
